import { api } from 'shared';
import { z } from 'zod';

export const SweetShopArticleCategoriesResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            slug: z.string(),
            name: z.string(),
            description: z.any().optional().nullable(),
            image: z.object({
                url: z.string(),
            }).optional().nullable(),
        }),
    ),
});
export const fetchSweetShopArticleCategories = async () => (
    api.get<z.infer<typeof SweetShopArticleCategoriesResponseSchema>>(
        '/sweet-shop-article-categories',
        {
            populate: {
                image: {
                    fields: 'url',
                },
            },
        },
        SweetShopArticleCategoriesResponseSchema,
    )
);
